import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';

const OnboardingModal = ({ isVisible, toggleRemoveOnboardingModal, handleContinue }) => {
  return (
    <Modal
      className='onboarding-modal'
      visible={isVisible}
      onClickBackdrop={toggleRemoveOnboardingModal}
    >
      <div className="modal-header">
        <a
          onClick={(e) => { e.preventDefault(); toggleRemoveOnboardingModal(); }}
          className="d-none close-onboarding-modal"
        >
          X
        </a>
      </div>
      <div className="modal-body">
        <h2>Welcome to Soono!</h2>
        <p>Enjoy 7 days of Soono at no cost</p>
        <p>
          You’re one step closer to getting to know your customers even better.{' '}
          Let us help you get acquainted with the system. You can skip guidance at any time.
        </p>
      </div>
      <div className="modal-footer p-0">
        <button
          type="button"
          className="btn btn-warning w-100 text-white pl-5 p-3"
          onClick={handleContinue}
        >
          SELECT A SURVEY TEMPLATE
      </button>
      </div>

    </Modal>
  );
};

OnboardingModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleRemoveOnboardingModal: PropTypes.func
};

export default OnboardingModal;



// WEBPACK FOOTER //
// ./src/components/dashboard/OnboardingModal.js